import React from 'react'
import getUid from '../utils/uidGenerator'

class Checkbox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            checked: this.props.checked ? this.props.checked : false,
        }
    }

    handleClick = () => {
        this.setState(
            {
                checked: !this.state.checked
            },
            () => { this.props.onClick && this.props.onClick(this.state.checked) }
        )
    }

    render() {

        let uid = getUid()

        return (
            <div className="js-checkbox ci-checkbox">
                <input type="checkbox" id={"checkbox_check" + uid} onChange={this.handleClick} checked={this.state.checked} disabled={this.props.disabled} />
                <label htmlFor={"checkbox_check" + uid} style={{ marginBottom: 0, ...this.props.style }}>
                    {this.props.children ? this.props.children : " "}
                    {this.state.checked}
                </label>
            </div>
        );
    }
}

export default Checkbox